<template>
  <div class="header--categories">
    <div class="container d-flex align-center">
      <div class="all--categories">
        <div
          v-for="(item, index) in subheaders"
          :key="`main-cat-header-${index}`"
          :class="{ selected: $route.path === item.url }"
        >
          <div v-if="item.enabled !== false" class="single--category">
            <router-link :to="item.url">
              <div class="header-category--label">
                <span>{{ $t(item.name) }}</span>
                <span v-if="item.isNew" class="featured-menu--highlight">
                  {{ $t('general.new') }}
                </span>
                <div v-if="item.unread" class="unread--counter">{{ item.unread }}</div>
              </div>
            </router-link>
          </div>
        </div>
        <v-menu
          offset-y
          nudge-bottom="10"
          content-class="featured-menu--content"
          :close-on-content-click="true"
        >
          <template v-slot:activator="{ on, attrs }">
            <button
              type="button"
              class="featured-menu--trigger"
              :class="{ selected: isFeaturedRoute }"
              v-bind="attrs"
              v-on="on"
            >
              <span class="featured-menu--text">Fitur Unggulan</span>
              <span class="featured-menu--highlight">BARU</span>
              <v-icon>mdi-chevron-down</v-icon>
            </button>
          </template>

          <div class="featured-menu--card">
            <router-link
              v-for="item in featuredMenus"
              :key="item.url"
              :to="item.url"
              class="featured-menu--item"
              :class="{ selected: $route.path === item.url }"
            >
              <div class="featured-menu--icon">
                <img :src="item.iconSrc" :alt="item.label" />
              </div>
              <div class="featured-menu--copy">
                <div class="featured-menu--title">
                  {{ item.label }}
                  <span v-if="item.isNew" class="featured-menu--badge">BARU</span>
                </div>
                <div class="featured-menu--desc">{{ item.description }}</div>
              </div>
              <v-icon class="featured-menu--arrow">mdi-arrow-right</v-icon>
            </router-link>
          </div>
        </v-menu>
      </div>
    </div>
  </div>
</template>

<script>
import HelperMixin from '@/mixins/helpers';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'header-categories',
  mixins: [HelperMixin],
  data: () => ({}),
  computed: {
    ...mapState({
      enquiriesUnreadCount: (state) => state.global.enquiriesUnreadCount,
      enableRecommendedListing: (state) => state.global.enableRecommendedListing,
    }),
    ...mapGetters({
      isProOrExecutive: 'global/isProOrExecutive',
    }),
    subheaders() {
      return [
        {
          name: 'home.sidebarMenu.product',
          url: '/product',
        },
        {
          name: 'home.sidebarMenu.myOrder',
          url: '/order',
        },
        {
          name: 'home.sidebarMenu.myListing',
          url: '/',
        },
        {
          name: 'home.sidebarMenu.myCoin',
          url: '/coin-purchase',
        },
        {
          name: 'home.sidebarMenu.recommendedListing',
          url: '/recommended-listing',
          isNew: true,
          enabled: this.enableRecommendedListing,
        },

        // {
        //   name: 'home.sidebarMenu.shortlist',
        //   url: '/shortlist',
        // },
        {
          name: 'home.sidebarMenu.myLeads',
          url: '/leads',
          unread: this.enquiriesUnreadCount,
        },
      ];
    },
    featuredMenus() {
      const menus = [
        {
          label: 'Agen Pilihan',
          url: '/layanan-agen/agen-properti-pilihan',
          iconSrc: require('@/assets/icons/featured-features/agen-pilihan.svg'),
          description: 'Tingkatkan visibilitas profil agen.',
        },
        {
          label: 'Agen Naik Kelas',
          url: '/layanan-agen/agen-naik-kelas',
          iconSrc: require('@/assets/icons/featured-features/agen-naik-kelas.svg'),
          description: 'Pantau progress badge performa agen.',
          isNew: true,
        },
      ];

      if (this.isProOrExecutive) {
        menus.push(
          {
            label: 'Owner Connect',
            url: '/layanan-agen/owner-connect',
            iconSrc: require('@/assets/icons/featured-features/owner-connect.svg'),
            description: 'Akses listing langsung dari owner.',
          },
          {
            label: 'Project Connect',
            url: '/layanan-agen/project-connect',
            iconSrc: require('@/assets/icons/featured-features/project-connect.svg'),
            description: 'Temukan project primary dari developer.',
            isNew: true,
          },
        );
      }

      return menus;
    },
    isFeaturedRoute() {
      return this.featuredMenus.some((item) => this.$route.path.startsWith(item.url));
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/utils/variables';

.featured-menu--trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 32px;
  padding: 0 9px 0 11px;
  border: 1px solid transparent;
  background: transparent;
  color: $color-text-black;
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 14px;
  transition: color 0.18s ease;

  .v-icon {
    color: #777777;
    font-size: 18px;
    transition: color 0.18s ease;
  }

  &:hover,
  &.selected {
    color: $color-beliruma-1;

    .v-icon {
      color: $color-beliruma-1;
    }
  }

  &.selected {
    .featured-menu--text::after {
      opacity: 1;
      transform: scaleX(1);
    }
  }
}

.featured-menu--text {
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -8px;
    height: 2px;
    border-radius: 999px;
    background: $color-beliruma-1;
    opacity: 0;
    transform: scaleX(0.72);
    transition: opacity 0.18s ease, transform 0.18s ease;
  }
}
</style>

<style lang="scss">
@import '@/assets/scss/utils/variables';

.featured-menu--content {
  border: 1px solid #ececec !important;
  border-radius: 16px !important;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12) !important;
  overflow: visible !important;

  &::before {
    content: '';
    position: absolute;
    top: -7px;
    left: 44px;
    width: 12px;
    height: 12px;
    background: #ffffff;
    border-left: 1px solid #ececec;
    border-top: 1px solid #ececec;
    transform: rotate(45deg);
  }
}

.featured-menu--card {
  position: relative;
  z-index: 1;
  display: grid;
  gap: 4px;
  width: 390px;
  padding: 10px;
  border: none;
  border-radius: 16px;
  background: #ffffff;
}

.featured-menu--item {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) 18px;
  gap: 11px;
  align-items: center;
  padding: 12px;
  border: 1px solid transparent;
  border-radius: 12px;
  color: #282828;
  text-decoration: none;
  transition: background-color 0.18s ease, border-color 0.18s ease, transform 0.18s ease;

  &:hover,
  &.selected {
    border-color: #f1dddd;
    background: #fffafa;
    color: #282828;
    text-decoration: none;
    transform: translateY(-1px);

    .featured-menu--icon {
      background: #fff4f4;
      border-color: #f0d1d3;
    }

    .featured-menu--arrow {
      color: $color-beliruma-1;
      opacity: 1;
      transform: translateX(2px);
    }
  }
}

.featured-menu--icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid #e7e7e7;
  border-radius: 10px;
  background: #ffffff;
  transition: border-color 0.18s ease, background-color 0.18s ease;

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
    display: block;
  }
}

.featured-menu--copy {
  min-width: 0;
}

.featured-menu--title {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #202020;
  font-family: Poppins-Bold, sans-serif;
  font-size: 14.5px;
  line-height: 1.25;
}

.featured-menu--badge {
  display: inline-flex;
  align-items: center;
  min-height: 18px;
  padding: 0 7px;
  border: 1px solid #ffd2d5;
  border-radius: 999px;
  background: #fff5f5;
  color: $color-beliruma-1;
  font-family: Poppins-Medium, sans-serif;
  font-size: 11px;
  line-height: 1;
  letter-spacing: 0;
}

.featured-menu--desc {
  margin-top: 4px;
  color: #666f7a;
  font-family: Poppins, sans-serif;
  font-size: 12px;
  line-height: 1.45;
}

.featured-menu--arrow {
  color: #bdbdbd;
  font-size: 17px;
  opacity: 0.7;
  transition: color 0.18s ease, opacity 0.18s ease, transform 0.18s ease;
}
</style>
